<template>
  <aside class="admin-sidebar p-3">
    <div class="sidebar-card h-100">
      <router-link :to="{ name: 'admin-dashboard' }" class="sidebar-brand">
        <img src="../assets/logo.svg" alt="Nihon Water Maintenance" class="sidebar-logo">
        <div>
          <div class="sidebar-brand-name">NWM CMS</div>
          <div class="sidebar-brand-copy">Water admin panel</div>
        </div>
      </router-link>

      <div class="sidebar-menu mt-4">
        <router-link class="sidebar-link" :to="{ name: 'admin-dashboard' }">Dashboard</router-link>
        <router-link class="sidebar-link" :to="{ name: 'admin-posts' }">Bài viết</router-link>
        <router-link class="sidebar-link" :to="{ name: 'admin-banners' }">Banner</router-link>
        <router-link class="sidebar-link" :to="{ name: 'admin-company-info' }">Công ty</router-link>
        <router-link class="sidebar-link" :to="{ name: 'admin-contacts' }">Liên hệ</router-link>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: "AdminSidebar"
};
</script>

<style scoped>
.admin-sidebar {
  width: 280px;
  min-height: 100vh;
}

.sidebar-card {
  position: sticky;
  top: 16px;
  background: linear-gradient(180deg, #003d99 0%, #022563 100%);
  border-radius: 28px;
  padding: 24px 20px;
  color: white;
}

.sidebar-brand {
  display: flex;
  gap: 14px;
  color: white;
  text-decoration: none;
}

.sidebar-logo {
  width: 58px;
  height: 58px;
  border-radius: 18px;
}

.sidebar-brand-name {
  font-size: 20px;
  font-weight: 800;
}

.sidebar-brand-copy {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
}

.sidebar-menu {
  display: grid;
  gap: 10px;
}

.sidebar-link {
  padding: 14px 16px;
  border-radius: 16px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-weight: 700;
}

.sidebar-link.router-link-exact-active,
.sidebar-link:hover {
  background: rgba(255, 255, 255, 0.12);
  color: white;
}

@media (max-width: 991px) {
  .admin-sidebar {
    display: none;
  }
}
</style>
